import jwt_decode from 'jwt-decode';
import * as appApi from '../../shared/globalcontants';

/**
 * Persists Identity token response into localStorage and derives expiry / session id from the access JWT.
 * Does not touch idle/session keys (Req 5).
 */
export function applyEatecTokenPayloadToStorage(payload: any): void {
  const accessToken = payload?.access_token ?? payload?.AccessToken;
  if (!accessToken) {
    return;
  }
  const refresh = payload.refresh_token ?? payload.RefreshToken;
  const prevRaw = localStorage.getItem(appApi.userSessionName);
  let merged: any = {};
  try {
    merged = prevRaw ? JSON.parse(prevRaw) : {};
  } catch {
    merged = {};
  }
  merged.access_token = accessToken;
  if (refresh != null) {
    merged.refresh_token = refresh;
  }
  const expIn = payload.expires_in ?? payload.ExpiresIn;
  if (expIn != null) {
    merged.expires_in = expIn;
  }
  localStorage.setItem(appApi.userSessionName, JSON.stringify(merged));

  try {
    const dec: any = jwt_decode(accessToken);
    if (dec?.exp != null) {
      localStorage.setItem(appApi.AccessTokenExpiresAtUnix, String(dec.exp));
    }
    const sid = dec?.SessionId ?? dec?.sessionId ?? dec?.sessionid;
    if (sid != null && sid !== '') {
      localStorage.setItem(appApi.EatecSessionId, String(sid));
    }
  } catch {
    /* ignore decode errors */
  }
}

export function clearEatecTokenAuxStorage(): void {
  localStorage.removeItem(appApi.AccessTokenExpiresAtUnix);
  localStorage.removeItem(appApi.EatecSessionId);
}
